export const feedbackTypes = {
    sales: "Sales",
    enquiry: "Enquiry",
    digital_lead: "Digital Leads",
    service: "Service",
    booking: "Booking",
};

export const digitalLeadsSources = [
    {
        value: "carWale",
        label: "Car Wale"
    },
    {
        value: "hyperlocal",
        label: "Hyperlocal"
    },
    {
        value: "carDekho",
        label: "Car Dekho"
    }
]